import React from 'react';
import { Box } from '@mui/material';
import ClockWidget from './ClockWidget';
import WeatherWidget from './WeatherWidget';
import DateWidget from './DateWidget';

const BarraInferior = () => {
  return (
    <Box sx={{ 
      flex: '1 1 auto',
      minHeight: 0,
      bgcolor: '#2c3e50', 
      p: 3, 
      display: 'flex', 
      justifyContent: 'space-around',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: { xs: 4, md: 0 },
      overflow: 'hidden'
    }}>
      <ClockWidget />
      <WeatherWidget />
      <DateWidget />
    </Box>
  );
};

export default BarraInferior; 